import { ChantiersService } from "~/services/chantiersService";
import { Link, Navigate } from "~/router";
import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { ArrowPathIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { BeatLoader } from "react-spinners";

export default function Index() {
  /* Le state permettant de gérer la recherche */
  const [search, setSearch] = useState("");

  /* le service d'API et le hook permettant de récupérer toutes les chantiers */
  const chantiersService = new ChantiersService();
  const {
    data: apiGetData,
    error: apiGetError,
    isLoading: apiGetIsLoading,
    callToAction: apiGetHandler,
  } = chantiersService.useGetAll();

  /* Le hook permettant de changer le titre de la page et le useEffect qui le fait */
  const [_, setPageTitle] = useOutletContext();

  useEffect(() => {
    setPageTitle("Liste des chantiers");
  }, []);

  /* Si erreur 401 not authenticated, on redirige vers la page de logout */
  if (apiGetError) {
    if (apiGetError.response && apiGetError.response.status === 401)
      return <Navigate to="/logout" />;
  }

  /* Render using table */
  return (
    <>
      {/* l'entête contenant le champs de recherche, le bouton de refresh, le loader et le bouton d'ajout */}
      <div className="flex justify-between w-full mb-4">
        <div className="flex flex-row items-center">
          <input
            className="rounded-md border-sky-600"
            type="text"
            placeholder="Rechercher"
            onChange={(e) => setSearch(e.target.value)}
          />

          {/* <button
            name="refresh"
            disabled={apiGetIsLoading}
            onClick={apiGetHandler}
            className="ml-8 px-4 border rounded-md border-sky-600 p-2 hover:bg-sky-600 hover:text-white transitions-colors duration-500"
          >
            <ArrowPathIcon className="h-4 inline" />
          </button> */}

          <BeatLoader size={10} loading={apiGetIsLoading} className="ml-8" />
        </div>

        <Link
          to="/chantiers/add"
          className="border rounded-md border-sky-600 p-2 hover:bg-sky-600 hover:text-white transitions-colors duration-500"
        >
          Ajouter
        </Link>
      </div>

      {/* L'erreur si présente */}
      <h1 className="text-red-600 w-full text-center">
        {apiGetError && apiGetError.message}
      </h1>

      {/* La table contenant les données */}
      <table
        className={`table-auto w-full border border-collapse rounded-xl ${
          apiGetIsLoading && "blur-sm"
        }`}
      >
        <thead>
          <tr>
            <th className="border border-collapse py-1"></th>
            <th className="border border-collapse py-1">Titre</th>
            <th className="border border-collapse">Client</th>
            <th className="border border-collapse">Adresse</th>
            <th className="border border-collapse">Ville</th>
            <th className="border border-collapse">Code Postal</th>
            <th className="border border-collapse">Téléphone(s)</th>
            <th className="border border-collapse">Phase</th>
            <th className="border border-collapse">Numéro du devis</th>
            <th className="border border-collapse">Devis HT</th>
            <th className="border border-collapse"></th>
          </tr>
        </thead>
        <tbody>
          {apiGetData &&
            apiGetData.map((chantier, i) => {
              const found =
              chantier.title && chantier.title.toLowerCase().includes(search.toLowerCase()) ||
              chantier.address && chantier.address.toLowerCase().includes(search.toLowerCase()) ||
              chantier.quote && chantier.quote.toLowerCase().includes(search.toLowerCase()) ||
              chantier.city && chantier.city.toLowerCase().includes(search.toLowerCase()) ||
              chantier.phase && chantier.phase.toLowerCase().includes(search.toLowerCase());
              if (found)
                return (
                  <tr
                    key={chantier.id}
                    className={`${
                      i % 2 === 0 && "bg-sky-100"
                    } hover:bg-sky-200 ${
                      chantier.archived === false && "font-italic text-gray-CCC"
                    }`}
                  >
                    <td
                      className="border border-collapse text-center uppercase py-1"
                      style={{ backgroundColor: `${chantier.color}` }}
                    >
                      &nbsp;
                    </td>
                    <td className="border border-collapse text-center uppercase py-1">
                      {chantier.title}
                    </td>
                    <td className="border border-collapse text-center uppercase py-1">
                      {chantier.client && chantier.client.name}
                    </td>
                    <td className="border border-collapse text-center lowercase">
                      {chantier.address}
                    </td>
                    <td className="border border-collapse text-center">
                      {chantier.city}
                    </td>
                    <td className="border border-collapse text-center">
                      {chantier.postal_code}
                    </td>
                    <td className="border border-collapse text-center">
                      {chantier.phone1}
                      {chantier.phone2 != null && " / " + chantier.phone2}
                    </td>
                    <td className="border border-collapse text-center">
                      {chantier.phase}
                    </td>
                    <td className="border border-collapse text-center">
                      {chantier.quote}
                    </td>
                    <td className="border border-collapse text-center">
                      {chantier.amount_no_taxes}
                    </td>
                    <td className="border border-collapse text-center">
                      <Link className="" to={`/chantiers/edit/${chantier.id}`}>
                        <ArrowRightIcon className="inline w-4" />
                      </Link>
                    </td>
                  </tr>
                );
            })}
        </tbody>
      </table>
    </>
  );
}
